
import { EmailSenderInfoStep } from "../form-steps/EmailSenderInfoStep"
import { EmailRecipientInfoStep } from "../form-steps/EmailRecipientInfoStep"
import { MailSenderInfoStep } from "../form-steps/MailSenderInfoStep"
import { MailRecipientInfoStep } from "../form-steps/MailRecipientInfoStep"
import { SituationStep } from "../form-steps/SituationStep"
import { EmailFormData, MailFormData } from "@/types/form"

interface FormStepRendererProps {
  step: number
  isEmailDelivery: boolean
  formData: EmailFormData | MailFormData
  handleInputChange: (section: 'sender' | 'recipient' | 'situation', field: string, value: string) => void
  showErrors: boolean
}

export function FormStepRenderer({ 
  step, 
  isEmailDelivery, 
  formData, 
  handleInputChange, 
  showErrors 
}: FormStepRendererProps) {
  if (isEmailDelivery) {
    switch (step) {
      case 1:
        return (
          <EmailSenderInfoStep
            formData={formData.sender}
            handleInputChange={(field, value) => handleInputChange("sender", field, value)}
            showErrors={showErrors}
          />
        )
      case 2:
        return (
          <EmailRecipientInfoStep
            formData={formData.recipient}
            handleInputChange={(field, value) => handleInputChange("recipient", field, value)}
            showErrors={showErrors}
          />
        )
      case 3:
        return (
          <SituationStep
            formData={formData.situation}
            handleInputChange={(field, value) => handleInputChange("situation", field, value)}
            showErrors={showErrors}
          />
        )
      default:
        return null
    }
  } else {
    switch (step) {
      case 1:
        return (
          <MailSenderInfoStep
            formData={formData.sender}
            handleInputChange={(field, value) => handleInputChange("sender", field, value)}
            showErrors={showErrors}
          />
        )
      case 2:
        return (
          <MailRecipientInfoStep
            formData={formData.recipient as MailFormData['recipient']}
            handleInputChange={(field, value) => handleInputChange("recipient", field, value)}
            showErrors={showErrors}
          />
        )
      case 3:
        return (
          <SituationStep
            formData={formData.situation}
            handleInputChange={(field, value) => handleInputChange("situation", field, value)}
            showErrors={showErrors}
          />
        )
      default:
        return null
    }
  }
}
